<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-note">
      <p>&copy; 2026 <a :href="site.domain" class="footer-link">{{ site.siteName }}</a> This site only shares guides and news about GBWhatsApp. All rights belong to their owners.</p>
    </div>
    <div class="footer-links">
      <router-link to="/about-us/" class="footer-link">About Us</router-link>
      |
      <router-link to="/contact-us/" class="footer-link">Contact Us</router-link>
      |
      <router-link to="/disclaimer/" class="footer-link">Disclaimer</router-link>
      |
      <router-link to="/privacy-policy/" class="footer-link">Privacy Policy</router-link>
    </div>

  </div>
</footer>
</template>

<script>
import site from '@/config/site.json';

export default {
  name: 'Footer',
  data() {
    return {
      site,
    };
  },
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: transparent;
  color: #121212;
  padding: 15px 0 28px;
}

.footer-container {
  width: min(1280px, calc(100% - 32px));
  margin: 0 auto;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  gap: 16px;
  white-space: nowrap;
}

.footer-links {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
  color: #121212;
  font-size: 13px;
}

.footer-link {
  color: #1b3d76;
  text-decoration: none;
  font-size: 13px;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #2880ba;
}

.footer-note {
  flex: 0 1 auto;
  min-width: 0;
  font-size: 13px;

  p {
    margin: 0;
  }
}

@media (max-width: 1100px) {
  .footer-container {
    flex-wrap: wrap;
    white-space: normal;
    text-align: center;
    row-gap: 8px;
  }

  .footer-links {
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 10px 0 50px;
  }

  .footer-container {
    flex-direction: column;
  }

  .footer-note {
    font-size: 12px;
  }
}
</style>
